/* Publish by EComposer at 2026-11-03 06:39:50*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-z339zunhca"]=  window.__ectimmers["ecom-z339zunhca"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-z339zunhca').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-z339zunhca', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-z339zunhca', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fu4i5pkah06').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fu4i5pkah06', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fu4i5pkah06', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u5h1f116dhh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u5h1f116dhh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u5h1f116dhh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-11hpha6itth').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-11hpha6itth', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-11hpha6itth', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-p0rr0eq8t5n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-p0rr0eq8t5n', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-p0rr0eq8t5n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9lwv9hbyysg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9lwv9hbyysg', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9lwv9hbyysg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-juxplbkphy8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-juxplbkphy8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-juxplbkphy8', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-almy0abauao').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-almy0abauao', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-almy0abauao', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-matvncnimw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-matvncnimw', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-matvncnimw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-eu47zw2ctv9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-eu47zw2ctv9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-eu47zw2ctv9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ayjq04gz9m6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ayjq04gz9m6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ayjq04gz9m6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-11845d9swnzm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-11845d9swnzm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-11845d9swnzm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5cnuvfwjmw').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5cnuvfwjmw', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5cnuvfwjmw', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-oq5j5qhj7qk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-oq5j5qhj7qk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-oq5j5qhj7qk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qd68r8myh1').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qd68r8myh1', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qd68r8myh1', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2aafxgtnimh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2aafxgtnimh', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2aafxgtnimh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yfb523409z').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yfb523409z', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yfb523409z', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-5uiuyp1685q').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-5uiuyp1685q', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-5uiuyp1685q', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cjiag8z4vgb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cjiag8z4vgb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cjiag8z4vgb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cvqycva9ffi').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cvqycva9ffi', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cvqycva9ffi', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vaq2eocg0dn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vaq2eocg0dn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vaq2eocg0dn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qlj3uluhaj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qlj3uluhaj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qlj3uluhaj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cpuy999ng9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cpuy999ng9', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cpuy999ng9', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jd4lcw508e').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jd4lcw508e', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jd4lcw508e', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a1htzn13pn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a1htzn13pn', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a1htzn13pn', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ntkkhaftly').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ntkkhaftly', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ntkkhaftly', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-x8blshgcby').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-x8blshgcby', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-x8blshgcby', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3xbj4shdlbl').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3xbj4shdlbl', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3xbj4shdlbl', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i1vyj1p2m1j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i1vyj1p2m1j', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i1vyj1p2m1j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-v2p4m2sfzjj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-v2p4m2sfzjj', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-v2p4m2sfzjj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gvi9ss16ex').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gvi9ss16ex', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gvi9ss16ex', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7sokxbrs7re').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7sokxbrs7re', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7sokxbrs7re', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dnog42o1824').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dnog42o1824', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dnog42o1824', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ncjqxl7l17').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ncjqxl7l17', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ncjqxl7l17', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-jbjsjzgk43i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-jbjsjzgk43i', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-jbjsjzgk43i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-y85tfbh32b').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-y85tfbh32b', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-y85tfbh32b', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wzrfzc4lfqm').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wzrfzc4lfqm', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wzrfzc4lfqm', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-x1on5lvnlc').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-x1on5lvnlc', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-x1on5lvnlc', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-q2n3t1ws8eb').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-q2n3t1ws8eb', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-q2n3t1ws8eb', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fctokd2okol').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fctokd2okol', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fctokd2okol', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gfzci0oajb6').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gfzci0oajb6', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gfzci0oajb6', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-cgbrzik334').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-cgbrzik334', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-cgbrzik334', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3250ihbiafo').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3250ihbiafo', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3250ihbiafo', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nvyg20p4j4').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nvyg20p4j4', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nvyg20p4j4', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-vbcbxs787yq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-vbcbxs787yq', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-vbcbxs787yq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-w5oys3xx33').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-w5oys3xx33', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-w5oys3xx33', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9vnt373iuvf"]=  window.__ectimmers["ecom-9vnt373iuvf"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const n=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},o=function(){e.removeEventListener("mousemove",n),e.removeEventListener("mouseup",o),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",n),e.addEventListener("mouseup",o)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",o)}

                    });
                    
                        document.querySelectorAll('.ecom-9vnt373iuvf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9vnt373iuvf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9vnt373iuvf', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-nlqzcx73zdk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-nlqzcx73zdk', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-nlqzcx73zdk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-j5e4sdwhsip').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-j5e4sdwhsip', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-j5e4sdwhsip', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ln16t22dnf').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ln16t22dnf', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ln16t22dnf', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9f021alx5i"]=  window.__ectimmers["ecom-9f021alx5i"] || {};
var d,p,m;const t=this.$el;if(!t||!t.isConnected)return;const e=t.querySelectorAll(".element__counter--number");if(!e.length)return;const i=window,n=(p=(d=this.settings)==null?void 0:d.thousandSeparator)!=null?p:!1,o=((m=this.settings)==null?void 0:m.smoothCount)!==!1,s=function(_){const b=String(_);return n?b.replace(/\B(?=(\d{3})+(?!\d))/g,","):b},r=function(_){_.ecomCounterRaf&&(i.cancelAnimationFrame(_.ecomCounterRaf),_.ecomCounterRaf=null);const b=Math.max(0,+_.getAttribute("data-duration")||1e3),y=+_.getAttribute("data-from-value")||0,v=+_.getAttribute("data-to-value")||0,w=Math.abs(+_.getAttribute("data-step"))||1,S=v-y,C=Math.max((String(y).split(".")[1]||"").length,(String(v).split(".")[1]||"").length,(String(w).split(".")[1]||"").length),x=function(T){_.textContent=s(C?+T.toFixed(C):T)};if(!S||typeof i.requestAnimationFrame!="function"){x(v);return}const $=Math.abs(S),E=S<0?-1:1,I=Math.min(120,Math.max(24,Math.round(b/16)));let j=w;if(o&&$/w<I){const T=C?Math.pow(10,-C):1,F=$/I;j=F>T?C?+F.toFixed(C):Math.round(F):T}let M=null;const D=function(T){if(!_.isConnected){_.ecomCounterRaf=null;return}M===null&&(M=T);const F=b>0?Math.min(1,(T-M)/b):1;if(F>=1){_.ecomCounterRaf=null,x(v);return}const H=o?1-Math.pow(1-F,3):F;x(y+E*Math.floor($*H/j)*j),_.ecomCounterRaf=i.requestAnimationFrame(D)};x(y),_.ecomCounterRaf=i.requestAnimationFrame(D)},a=function(_){_.ecomCounterFired||(_.ecomCounterFired=!0,r(_))};if(t.ecomCounterObserver&&(t.ecomCounterObserver.disconnect(),t.ecomCounterObserver=null),typeof i.IntersectionObserver!="function"){e.forEach(a);return}let l=e.length;const c=new i.IntersectionObserver(function(_){_.forEach(function(b){!b.isIntersecting||(c.unobserve(b.target),l--,a(b.target))}),l<=0&&(c.disconnect(),t.ecomCounterObserver=null)},{threshold:0});t.ecomCounterObserver=c,e.forEach(function(_){_.ecomCounterFired=!1,c.observe(_)})

                    });
                    
                        document.querySelectorAll('.ecom-9f021alx5i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9f021alx5i', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9f021alx5i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-k0cdzkeb95').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-k0cdzkeb95', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-k0cdzkeb95', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-u06tr33zuh8').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-u06tr33zuh8', settings: {},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-u06tr33zuh8', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-gvkxd7a238n"]=  window.__ectimmers["ecom-gvkxd7a238n"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-gvkxd7a238n"]["wctxcx5fy"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-gvkxd7a238n').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gvkxd7a238n', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gvkxd7a238n', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-dzvynrdityv').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-dzvynrdityv', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-dzvynrdityv', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-glveu3xylms').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-glveu3xylms', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-glveu3xylms', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-7yack8mnik').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-7yack8mnik', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-7yack8mnik', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-8e5okzfhplx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-8e5okzfhplx', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-8e5okzfhplx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-qrjg3y07sbg').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-qrjg3y07sbg', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-qrjg3y07sbg', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-2r0qxer5bhu').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-2r0qxer5bhu', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-2r0qxer5bhu', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-n8o35duswcq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-n8o35duswcq', settings: {"animation":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-n8o35duswcq', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-t2ta0nrfec"]=  window.__ectimmers["ecom-t2ta0nrfec"] || {};
var $,E,I,j,M,D;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,n=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,s=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(M=this.settings.disable_effect)!=null?M:!1,a=(D=this.settings.close_all)!=null?D:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||n&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,de=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(de).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(de.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(de.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=s||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-t2ta0nrfec').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-t2ta0nrfec', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-t2ta0nrfec', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-g7j3sk43kp').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-g7j3sk43kp', settings: {"disable_auto_close":false,"disable_effect":false,"close_all":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-g7j3sk43kp', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-87tfchs6z3j"]=  window.__ectimmers["ecom-87tfchs6z3j"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-87tfchs6z3j"]["cdh1g25jn"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-87tfchs6z3j').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-87tfchs6z3j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-87tfchs6z3j', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-udax8b4s27p').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-udax8b4s27p', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-udax8b4s27p', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-0l0qtkcnigsh').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-0l0qtkcnigsh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-0l0qtkcnigsh', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-wuptgdkwssa').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-wuptgdkwssa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-wuptgdkwssa', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9isqxryq4a').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9isqxryq4a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9isqxryq4a', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-fg4xzsh6zj').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-fg4xzsh6zj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-fg4xzsh6zj', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ea65kycxnn').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ea65kycxnn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ea65kycxnn', e);
                            }
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4b86loncmto"]=  window.__ectimmers["ecom-4b86loncmto"] || {};
var H,R,K,W,G,se,te,Y,pe,de,he,J,V;var t=this.$el&&this.$el.querySelector(".ecom-swiper-autoplay-toggle");if(t&&!t.getAttribute("data-ecom-bound")){t.setAttribute("data-ecom-bound","1");var e=this.$el.querySelector(".ecom-swiper-container");t.addEventListener("click",function(){var X=e&&e.swiper;!X||!X.autoplay||(X.autoplay.running?(X.autoplay.stop(),t.setAttribute("data-state","paused"),t.setAttribute("aria-label",t.getAttribute("data-label-play"))):(X.autoplay.start(),t.setAttribute("data-state","playing"),t.setAttribute("aria-label",t.getAttribute("data-label-pause"))))})}const i=this.$el;if(!i)return;const n=i.querySelector(".ecom-autoplay-progress svg"),o=i.querySelector(".ecom-autoplay-progress span"),s=(H=this.settings.disable_lazy)!=null?H:!1,r=window.EComposer&&typeof window.EComposer.normalizeSwiperSettings=="function"?window.EComposer.normalizeSwiperSettings(this.settings):this.settings,a=r.slider_loop,l=r.slider_center,c=(R=r.slider_center__tablet)!=null?R:r.slider_center,d=(W=(K=r.slider_center__mobile)!=null?K:r.slider_center__tablet)!=null?W:r.slider_center,p=r.slider_group,m=r.slider_items,_=(G=r.slider_group__tablet)!=null?G:r.slider_group,b=(se=r.slider_items__tablet)!=null?se:r.slider_items,y=(Y=(te=r.slider_group__mobile)!=null?te:r.slider_group__tablet)!=null?Y:r.slider_group,v=(de=(pe=r.slider_items__mobile)!=null?pe:r.slider_items__tablet)!=null?de:r.slider_items,w=r.slider_speed,S=(he=r.slider_speed__tablet)!=null?he:r.slider_speed,C=(J=r.slider_speed__mobile)!=null?J:r.slider_speed,x=function(X){if(window.EComSwiper)return X();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("slider_js").then(function(){window.EComSwiper&&X()});return}let Q=0;const ge= window.__ectimmers["ecom-4b86loncmto"]["6qn3iidmp"] = setInterval(function(){window.EComSwiper?(clearInterval(ge),X()):++Q>=300&&clearInterval(ge)},50)},$=function(X){return window.EComposer&&typeof window.EComposer.buildSwiperConfig=="function"?window.EComposer.buildSwiperConfig(X):null},E=function(X,Q={},ge=""){return ge=="loop"?(X.items&&(window.innerWidth>1024&&X.items.length<p+m||window.innerWidth<=1024&&window.innerWidth>768&&X.items.length<_+b||X.items.length<y+v)&&(Q.loop=!1),Q):(window.innerWidth<=1024&&window.innerWidth>768&&X[1]?Q[`${ge}`]=X[1]:window.innerWidth<768&&X[2]?Q[`${ge}`]=X[2]:X[0]&&(Q[`${ge}`]=X[0]),Q)};let I={};n&&o&&(I={autoplayTimeLeft(X,Q,ge){n.style.setProperty("--progress",1-ge),o.textContent=`${Math.ceil(Q/1e3)}s`}});const j=i.querySelector(".ecom-swiper-container"),M=(V=r.disable_touch_move)!=null?V:!0;if(!j)return;const D=this,T=function(X){const Q=i.querySelector(`.ecom-swiper-pagination[data-ecnav-id="${D.id}"]`),ge=i.querySelector(`.ecom-swiper-button-next[data-ecnav-id="${D.id}"]`),ee=i.querySelector(`.ecom-swiper-button-prev[data-ecnav-id="${D.id}"]`);X.pagination.el=Q,X.navigation.nextEl=ge,X.navigation.prevEl=ee,X.pagination.renderBullet=(_e,we)=>`<span class="${we}">
                          ${r.items&&r.items[_e]&&r.items[_e].slider_pagination_image?`<img src="${r.items[_e].slider_pagination_image}">`:""}</span>`,I.init=function(){this.el.parentNode.classList.add("ecom-swiper-initialized-wrapper")};const ue={allowTouchMove:D.isLive&&M,on:I};X.watchSlidesProgress=!0,x(function(){let _e=null;function we(){a&&(X.loop=!0,X=E(r,X,"loop")),X.centeredSlides=!1,X=E([l,c,d],X,"centeredSlides"),X=E([w,S,C],X,"speed"),_e=new window.EComSwiper(j,Object.assign(X,ue)),X.autoplay.enabled&&(_e.on("touchStart",function(ze,Ne){ze.params.speed=300,ze.autoplay.stop()}),_e.on("touchEnd",function(ze,Ne){window.innerWidth>1024&&w&&(ze.params.speed=w),window.innerWidth<=1024&&window.innerWidth>768&&S?ze.params.speed=S:w&&(ze.params.speed=w),window.innerWidth<768&&C?ze.params.speed=C:S?ze.params.speed=S:w&&(ze.params.speed=w),ze.autoplay.start()})),_e.on("slideChange",function(){const ze=_e.activeIndex==0?_e.slides.length-1:_e.activeIndex-1,Ne=_e.slides[ze];if(Ne){const Be=Ne.querySelectorAll(".ecom-animation.ecom-animated");Be.length&&Be.forEach(function(Ke){Ke.classList.remove("ecom-animated","animated"),Ke.classList.add("ecom-animated-slider")})}_e.el&&_e.slides.filter(Ke=>Ke.classList.contains("ecom-swiper-slide-visible")).forEach(Ke=>{let Xe=null;Ke&&Ke.nodeType===1&&(Xe=Ke.querySelectorAll(".ecom-animation.ecom-animated-slider"),Xe&&Xe.length&&Xe.forEach(function(at){at.classList.add("ecom-animated")}))})})}var Ae;D.isLive&&window.addEventListener("resize",function(){Ae&&clearTimeout(Ae),Ae=setTimeout(()=>{_e.update()},200)}),D.isLive?we():setTimeout(function(){we()},200)})};let F=$(r);if(!F){let X=0;const Q= window.__ectimmers["ecom-4b86loncmto"]["i2gsflis6"] = setInterval(function(){X++;const ge=$(r);ge?(clearInterval(Q),T(ge)):X>=20&&clearInterval(Q)},200);return}T(F),j.querySelectorAll("img").length&&j.querySelectorAll("img").forEach(function(X,Q){s&&X.removeAttribute("loading")})

                    });
                    
                        document.querySelectorAll('.ecom-4b86loncmto').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4b86loncmto', settings: {"items":[{"id":"ecom-pj6bzdkv8tp","slider_pagination_image":null},{"id":"ecom-kbziphtg2yp","slider_pagination_image":null},{"id":"ecom-dw4vyf73vq","slider_pagination_image":null},{"id":"ecom-djrrds0ttme","slider_pagination_image":null},{"id":"ecom-2fakptw11f9","slider_pagination_image":null},{"id":"ecom-v6gip2ozu6f","slider_pagination_image":null},{"id":"ecom-j207fz1mty","slider_pagination_image":null},{"id":"ecom-pvqbno0rjug","slider_pagination_image":null},{"id":"ecom-uteq07arsko","slider_pagination_image":null},{"id":"ecom-0mtapwj1dif","slider_pagination_image":null},{"id":"ecom-9qdiq5xs0yi","slider_pagination_image":null},{"id":"ecom-yypyn3vg5h8","slider_pagination_image":null}],"slider_navigation_layout":"navigation","slider_prev_icon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-left\"><polyline points=\"15 18 9 12 15 6\"></polyline></svg>","slider_next_icon":"<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"52\" height=\"52\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-chevron-right\"><polyline points=\"9 18 15 12 9 6\"></polyline></svg>","slider_effect":"slide","isCustomHeight":false,"verticalAlign":"center","slider_autoplay":false,"slider_items":4.5,"slider_loop":true,"slider_autoplay_speed":6000,"slider_items__mobile":1.2,"slider_spacing__mobile":15,"slider_items__tablet":2.8,"slider_spacing_row__tablet":30,"slider_style":"horizontal","slider_group":1,"slider_spacing":30,"slider_speed":500,"slider_spacing__tablet":16,"contentWidth":"100%","slider_spacing_row__mobile":15,"navigation_position__tablet":"bottom_center","navigation_position__mobile":"bottom_center","navigation_position":"bottom_center"},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4b86loncmto', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}